<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">申请人信息</div>
        <div class="wt-tab-info-content wt-tab-base">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">订单编号：</span>
            <span class="wt-tab-base-value">{{ detailFormData.id }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">社区：</span>
            <span class="wt-tab-base-value">{{ detailFormData.communityName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点名称：</span>
            <span class="wt-tab-base-value">{{ detailFormData.siteName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点位置：</span>
            <span class="wt-tab-base-value">{{ detailFormData.siteAddress }}</span>
          </div>
          <div class="wt-tab-base-item" v-if="detailFormData.type === 2">
            <span class="wt-tab-base-label">申请时间：</span>
            <span class="wt-tab-base-value">{{ detailFormData.siteApproveTime }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">申请状态：</span>
            <span class="wt-tab-base-value">{{ detailFormData.stateName }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">审批信息</div>
        <div class="wt-tab-info-content wt-tab-base wt-tab-info-content-text">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">申请人：</span>
            <span class="wt-tab-base-value">{{ detailFormData.employeesName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">申请时间：</span>
            <span class="wt-tab-base-value">{{ detailFormData.siteApproveTime }}</span>
          </div>
        </div>
        <div class="wt-tab-info-content wt-tab-base wt-tab-info-content-text">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">区域负责人：</span>
            <span class="wt-tab-base-value">{{ detailFormData.areaManagerName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批时间：</span>
            <span class="wt-tab-base-value">{{ detailFormData.areaManagerApproveTime }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批结果：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.state > 1">
              <template v-if="detailFormData.state === 8">审批拒绝</template>
              <template v-if="detailFormData.state > 8">审批通过</template>
            </span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批意见：</span>
            <span class="wt-tab-base-value">{{ detailFormData.areaManagerApproveRemark }}</span>
          </div>
        </div>
        <div class="wt-tab-info-content wt-tab-base wt-tab-info-content-text">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">平台负责人：</span>
            <span class="wt-tab-base-value">{{ detailFormData.systemName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批时间：</span>
            <span class="wt-tab-base-value">{{ detailFormData.systemApproveTime }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批结果：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.state > 2">
              <template v-if="detailFormData.state === 9">审批拒绝</template>
              <template v-if="detailFormData.state === 10">审批通过</template>
            </span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">审批意见：</span>
            <span class="wt-tab-base-value">{{ detailFormData.systemApproveRemark }}</span>
          </div>
        </div>
        <div class="wt-tab-info-content wt-tab-base" v-if="detailFormData.type !== 3">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">收货站长：</span>
            <span class="wt-tab-base-value">{{ detailFormData.operatorName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">手机号：</span>
            <span class="wt-tab-base-value">{{ detailFormData.operatorPhone }}</span>
          </div>
        </div>
      </div> -->

     <div class="wt-tab-info-card" v-if="detailFormData.type === 3">
        <div class="wt-tab-info-title">出库信息</div>
        <div class="wt-tab-info-content wt-tab-base">
          <!-- <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">预计到达时间：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.approveCar">{{ detailFormData.approveCar.arriveTime }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">司机姓名：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.approveCar">{{ detailFormData.approveCar.carName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">司机手机号：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.approveCar">{{ detailFormData.approveCar.carPhone }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">车牌照号：</span>
            <span class="wt-tab-base-value" v-if="detailFormData.approveCar">{{ detailFormData.approveCar.carCard }}</span>
          </div> -->
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">实际出库时间：</span>
            <span class="wt-tab-base-value">{{ detailFormData.operatorTime }}</span>
            <!-- <span class="wt-tab-base-value" v-if="detailFormData.approveCar && detailFormData.state === 11">{{ detailFormData.approveCar.updateTime }}</span> -->
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">出库站长：</span>
            <span class="wt-tab-base-value">{{ detailFormData.operatorName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">手机号：</span>
            <span class="wt-tab-base-value">{{ detailFormData.operatorPhone }}</span>
          </div>
        </div>
      </div>

      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">物品信息</div>
        <div class="wt-tab-info-content wt-tab-base wt-tab-info-content-text">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">附件：</span>
            <el-image
                v-if="detailFormData.photo"
                style="width: 50px; height: 50px"
                :src="imgUrl + detailFormData.photo"
                :preview-src-list="[imgUrl + detailFormData.photo]"></el-image>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">备注：</span>
            <span class="wt-tab-base-value">{{ detailFormData.remark }}</span>
          </div>
        </div>
        <div class="wt-tab-info-content">
          <wt-form-table :form.sync="siteForm" @on-button-action="onButtonAction">
            <wt-form-table-list slot="wtFormTableList" :form.sync="siteForm" @on-button-action="onButtonAction">
              <template slot="count" slot-scope="data">
                {{ detailFormData.type === 3 ? $wtUtil.transWeight(data.row.count) : data.row.count}}
              </template>
              <template slot="countCurrent" slot-scope="data">
                {{ detailFormData.type === 3 ? (data.row.countCurrent ? $wtUtil.transWeight(data.row.countCurrent) : '') : data.row.countCurrent}}
              </template>
              <template slot="countReal" slot-scope="data">
                {{ detailFormData.type === 3 ? (data.row.countReal ? $wtUtil.transWeight(data.row.countReal) : '') : data.row.countReal}}
              </template>
              <template slot="photo" slot-scope="data">
                <wt-auth slot="error" class="search-form-btn">
                  <el-button size="mini" type="primary" @click="toViewImg(data.row)">查看</el-button>
                </wt-auth>
              </template>
              <template slot="wtFormTableListButtonsAfter" slot-scope="data">
                <wt-auth slot="error" class="search-form-btn" v-if="detailFormData.state === 11 || detailFormData.state === 6 || detailFormData.state === 7">
                  <el-button size="mini" type="primary" @click="toCheck(data.row)">纠错</el-button>
                </wt-auth>
              </template>
            </wt-form-table-list>
          </wt-form-table>
        </div>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <el-dialog
      title="纠错"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      key="1"
      :modal="false"
      :before-close="handleDialogClose">
      <div>
        <el-form v-if="dialogVisible" :model="formData" ref="approvalCheckDialogForm" label-width="150px" class="dialog-form-wrap">
          <el-form-item v-if="detailFormData.type !== 3" label="数量：" prop="countCurrent"
            :rules="[
              { required: true, message: '数量不能为空'},
              { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' }
            ]"
          >
            <el-input v-model.trim="formData.countCurrent" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item v-if="detailFormData.type === 3" label="实际出库重量：" prop="countReal"
            :rules="[
              { required: true, message: '数量不能为空'},
              { validator: $wtValidator.ValidatorGreaterZeroFloat, trigger: 'blur' },
              { validator: $wtValidator.ValidatorWeightLength, trigger: 'blur' }
            ]"
          >
            <el-input v-model.trim="formData.countReal" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm">保 存</el-button>
      </span>
    </el-dialog>
    <image-viewer :z-index="999" :initial-index="0" v-if="showViewer" :on-close="closeViewer" :url-list="previewSrcList"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageViewer from '@/components/image-viewer/index.vue'
export default {
  name: 'ApprovalManageViewPage',
  props: ['component-type'],
  isAutoComponent: true,
  components: { ImageViewer },
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      siteForm: {
        hidePage: true,
        noRequest: true,
        isFormLoading: false,
        formComponent: {},
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '物品名称', key: 'name', type: 'text' },
          { name: '申请出库（重量）', key: 'count', type: 'custom' },
          { name: '出库当日（重量）', key: 'countReal', type: 'custom' },
          { name: '实际出库（重量）', key: 'countCurrent', type: 'custom' },
          { name: '图片', key: 'photo', type: 'custom' }],
        formTableButtonsData: [],
        formResult: { list: [] },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: true }
      },
      detailFormButtons: {
        title: '区域负责人详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      dialogVisible: false,
      formData: {},
      showViewer: false,
      previewSrcList: []
    }
  },
  mounted() {
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {
    },
    toCheck(row) {
      this.formData = JSON.parse(JSON.stringify(row))
      if (this.detailFormData.type === 3) {
        this.formData.countReal = row.countReal / 1000
      }
      this.dialogVisible = true
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    submitForm() {
      const that = this
      this.$refs.approvalCheckDialogForm.validate((valid) => {
        if (valid) {
          if (that.detailFormData.type === 1) {
            that.$api.approval.updateGoodsCountReal(this.formData).then(res => {
              that.toSuccess()
            })
          }
          if (that.detailFormData.type === 2) {
            that.$api.approval.updateConsumablesCountReal(this.formData).then(res => {
              that.toSuccess()
            })
          }
          if (that.detailFormData.type === 3) {
            this.formData.countReal = this.formData.countReal * 1000
            that.$api.approval.updateGarbageCountReal(this.formData).then(res => {
              that.toSuccess()
            })
          }
        } else {
          return false
        }
      })
    },
    toSuccess() {
      this.$message({ message: '保存成功', type: 'success' })
      this.handleDialogClose()
      this.$store.dispatch('queryApprovalDetailData', this.detailFormData.id).then(res => {
        this.$store.dispatch('removeBreadcrumb')
      })
    },
    toViewImg(row) {
      if (row.photo && row.photo.length > 0 && row.photo !== '无') {
        this.previewSrcList = [this.imgUrl + row.photo]
        this.showViewer = true
      } else {
        this.$message({ message: '未上传图片', type: 'warning' })
      }
    },
    closeViewer() {
      this.showViewer = false
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.approvalManage.approvalDetailData
    })
  },
  watch: {
    detailFormData(val) {
      if (val) {
        if (val.type === 1) {
          this.$store.dispatch('appendBreadcrumb', {
            meta: { title: '补货详情' }})
          this.siteForm.formTableData[0].name = '商品名称'
          this.siteForm.formTableData[0].key = 'title'
          this.siteForm.formTableData[1].name = '申请数量'
          this.siteForm.formTableData[2].name = '发货数量'
          this.siteForm.formTableData[2].key = 'countReal'
          this.siteForm.formTableData[3].name = '收货数量'
          this.siteForm.formTableData[3].key = 'countCurrent'
          this.siteForm.formResult.list = val.approveDetailGoods
        }
        if (val.type === 2) {
          this.$store.dispatch('appendBreadcrumb', {
            meta: { title: '耗材详情' }})
          this.siteForm.formTableData[0].name = '耗材名称'
          this.siteForm.formTableData[0].key = 'name'
          this.siteForm.formTableData[1].name = '申请数量'
          this.siteForm.formTableData[2].name = '发货数量'
          this.siteForm.formTableData[2].key = 'countReal'
          this.siteForm.formTableData[3].name = '到货数量'
          this.siteForm.formTableData[3].key = 'countCurrent'
          if (this.siteForm.formTableData.length === 5) {
            this.siteForm.formTableData.pop()
          }
          this.siteForm.formResult.list = val.approveDetailConsumables
        }
        if (val.type === 3) {
          this.$store.dispatch('appendBreadcrumb', {
            meta: { title: '出库详情' }})
          this.siteForm.formTableData[0].name = '物品名称'
          this.siteForm.formTableData[0].key = 'name'
          this.siteForm.formTableData[1].name = '申请出库（重量）'
          this.siteForm.formTableData[2].name = '出库当日（重量）'
          this.siteForm.formTableData[2].key = 'countCurrent'
          this.siteForm.formTableData[3].name = '实际出库（重量）'
          this.siteForm.formTableData[3].key = 'countReal'
          if (this.siteForm.formTableData.length === 4) {
            this.siteForm.formTableData.push({ name: '图片', key: 'photo', type: 'custom' })
          }
          this.siteForm.formResult.list = val.approveDetailGarbage
        }
      }
    }
  }
}
</script>
